import React from 'react';
import LandingPageCreator from './LandingPageCreator';
import LandingPagesList from './LandingPagesList';
import './LandingPageModal.css';

interface LandingPageModalProps {
    isOpen: boolean;
    mode: 'create' | 'list';
    projectId?: string;
    onClose: () => void;
    onSuccess?: () => void;
}

const LandingPageModal: React.FC<LandingPageModalProps> = ({
    isOpen,
    mode,
    projectId,
    onClose,
    onSuccess
}) => {
    if (!isOpen) return null;

    const handleSuccess = () => {
        if (onSuccess) {
            onSuccess();
        }
        onClose();
    };

    return (
        <div className="modal-overlay landing-page-modal-overlay" onClick={onClose}>
            <div className="modal-content landing-page-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>{mode === 'create' ? 'Create Landing Page' : 'Landing Pages'}</h3>
                    <button className="modal-close-btn" onClick={onClose}>✕</button>
                </div>

                <div className="modal-body">
                    {mode === 'create' ? (
                        <LandingPageCreator
                            onCancel={onClose}
                            onSuccess={handleSuccess}
                            projectId={projectId}
                        />
                    ) : (
                        <LandingPagesList
                            onClose={onClose}
                            projectId={projectId}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default LandingPageModal;
